import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import 'react-accessible-accordion/dist/fancy-example.css';

import { getTokenInfo } from './../../../UseToken';
import { reqGET } from '../../../Utils';

import Loader from '../../Loader/Loader';

import {api_crud_route, data_interface, endpoints } from './Config';

export default function View(props) {

    const [, set_dados] = useState(data_interface);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

     // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÃ�GINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);



    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            
            <Loader />
        
            :
            
            <main>
                
            </main>
}